'use client';

import { usePathname, useRouter } from '@/i18n/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { locales, localeNames } from '@/i18n/config';
import type { Locale } from '@/i18n/config';

export default function LanguageSwitcher() {
  const t = useTranslations('LanguageSwitcher');
  const locale = useLocale() as Locale;
  const router = useRouter();
  const pathname = usePathname();

  const handleLocaleChange = (newLocale: string) => {
    router.replace(pathname, { locale: newLocale });
  };

  return (
    <div className="language-switcher" style={{
      display: 'flex',
      alignItems: 'center',
      background: 'rgba(0, 0, 0, 0.4)',
      padding: '6px 12px',
      borderRadius: '8px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    }}>
      <label 
        htmlFor="language-select"
        style={{ 
          fontSize: '14px', 
          marginRight: '8px',
          whiteSpace: 'nowrap',
        }}
      >
        {t('language')}:
      </label>
      <select 
        id="language-select"
        value={locale} 
        onChange={(e) => handleLocaleChange(e.target.value)}
        aria-label={t('language')}
        style={{
          background: 'rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px',
          outline: 'none',
        }}
      >
        {locales.map((loc) => (
          <option key={loc} value={loc}>
            {t(loc)}
          </option>
        ))}
      </select>
    </div>
  );
} 